import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  token: string;
  formId: number;
  fileEntitiesIds: number[];
}

export const deleteCustomFormFieldsFilesRequest = ({
                                                     token,
                                                     formId,
                                                     fileEntitiesIds,
                                                   }: RequestParams): Promise<void> => {
  return ApiServiceInstance.makeRequest(`/custom-form/${ formId }/file-fields`, {
    method: 'DELETE',
    token,
    body: fileEntitiesIds,
  });
};